var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.4 298.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.6,71.2c22.7,0,44,1.1,62.8,3V54.3A54.41,54.41,0,0,0,115.1,0H94.3A54.41,54.41,0,0,0,40,54.3V74.8A611,611,0,0,1,106.6,71.2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.2,88.3a95.17,95.17,0,0,0-19.1,1.9,273.06,273.06,0,0,1-51.8,5h-7.2a273.85,273.85,0,0,1-51.8-5,112.4,112.4,0,0,0-19.1-1.9C13.6,88.3,0,94.4,0,101.9s13.6,13.6,30.2,13.6h9.7c0-10,29.1-18.3,64.8-18.3s64.8,8.3,64.8,18.3h9.7c16.6,0,30.2-6.1,30.2-13.6S195.8,88.3,179.2,88.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.9,167c-4.7,2.8-12.2,4.4-20.2,4.4s-15.2-1.7-20.2-4.4a56.09,56.09,0,0,0-36,52.3,56.66,56.66,0,0,0,16.6,39.9l39.3,39.3,39.3-39.3a56,56,0,0,0,16.6-39.9A54.58,54.58,0,0,0,124.9,167Zm-20.2,76.9a24.6,24.6,0,1,1,24.6-24.6A24.65,24.65,0,0,1,104.7,243.9Z",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset1.b18d9f48.svg";
export { ForwardRef as ReactComponent };